import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import { useRef, useEffect, useState, useCallback } from "react";

function _defineProperty(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}

function ownKeys(r, e) {
  var t = Object.keys(r);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    })), t.push.apply(t, n);
  }

  return t;
}

function _objectSpread2(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ownKeys(Object(t), !0).forEach(function (e) {
      _defineProperty(r, e, t[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(t, e));
    });
  }

  return r;
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(r)) return Array.from(r);
}

function _iterableToArrayLimit(r, e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(r)) {
    var t = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var a, c = r[Symbol.iterator](); !(n = (a = c.next()).done) && (t.push(a.value), !e || t.length !== e); n = !0) {
        ;
      }
    } catch (r) {
      o = !0, i = r;
    } finally {
      try {
        n || null == c["return"] || c["return"]();
      } finally {
        if (o) throw i;
      }
    }

    return t;
  }
}

function _unsupportedIterableToArray(r, e) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, e) : void 0;
  }
}

function _arrayLikeToArray(r, e) {
  (null == e || e > r.length) && (e = r.length);

  for (var t = 0, n = new Array(e); t < e; t++) {
    n[t] = r[t];
  }

  return n;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useLatest = function useLatest(r) {
  var e = useRef(r);
  return useEffect(function () {
    e.current = r;
  }, [r]), e;
},
    observerErr = "💡react-cool-inview: the browser doesn't support Intersection Observer, please install polyfill: https://github.com/wellyshen/react-cool-inview#intersection-observer-polyfill",
    observerWarn = "💡react-cool-inview: the browser doesn't support Intersection Observer v2, fallback to v1 behavior",
    useInView = function useInView(r) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      t = e.root,
      n = e.rootMargin,
      o = e.threshold,
      i = e.trackVisibility,
      a = e.delay,
      c = e.unobserveOnEnter,
      u = void 0 !== c && c,
      s = e.onChange,
      l = e.onEnter,
      y = e.onLeave,
      b = useState({
    inView: !1,
    scrollDirection: {}
  }),
      f = _slicedToArray(b, 2),
      p = f[0],
      v = f[1],
      d = useRef(!1),
      h = useRef({}),
      w = useRef(!1),
      _ = useRef(null),
      m = useRef(!1),
      O = useLatest(s),
      A = useLatest(l),
      g = useLatest(y),
      j = useCallback(function () {
    !w.current && _.current && (_.current.observe(r.current), w.current = !0);
  }, [r]),
      S = useCallback(function () {
    w.current && _.current && (_.current.disconnect(), w.current = !1);
  }, []);

  return useEffect(function () {
    return r && r.current ? "IntersectionObserver" in window && "IntersectionObserverEntry" in window ? (_.current = new IntersectionObserver(function (r) {
      var e = _slicedToArray(r, 1)[0],
          t = e.intersectionRatio,
          n = e.isIntersecting,
          a = e.boundingClientRect,
          c = a.x,
          s = a.y,
          l = e.isVisible,
          y = {},
          b = Array.isArray(o) ? Math.min.apply(Math, _toConsumableArray(o)) : o,
          f = void 0 !== n ? n : t > 0;

      b > 0 && (f = t >= b), c < h.current.x && (y.horizontal = "left"), c > h.current.x && (y.horizontal = "right"), h.current.x = c, s < h.current.y && (y.vertical = "up"), s > h.current.y && (y.vertical = "down"), h.current.y = s;
      var p = {
        entry: e,
        scrollDirection: y,
        observe: j,
        unobserve: S
      };
      i && (void 0 !== l || m.current || (console.warn(observerWarn), m.current = !0), void 0 !== l && (f = l)), f && !d.current && (u && S(), A.current && A.current(p)), !f && d.current && g.current && g.current(p), O.current && O.current(_objectSpread2(_objectSpread2({}, p), {}, {
        inView: f
      })), v({
        inView: f,
        scrollDirection: y,
        entry: e
      }), d.current = f;
    }, {
      root: t,
      rootMargin: n,
      threshold: o,
      trackVisibility: i,
      delay: a
    }), j(), function () {
      S();
    }) : (console.error(observerErr), function () {
      return null;
    }) : function () {
      return null;
    };
  }, [r, u, t, n, JSON.stringify(o), i, a, j, S]), _objectSpread2(_objectSpread2({}, p), {}, {
    observe: j,
    unobserve: S
  });
};

export default useInView;
export { observerErr, observerWarn };